import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { PublicFormRenderer } from "./IntakeForms";
import { API_BASE, formatApiError } from "../components/AuthContext";

/**
 * v68.21 UI — Public intake form landing page.
 *
 * Renders at `/f/:slug`. No auth. Reads the form spec from
 * `GET /api/public/intake-forms/{slug}` and POSTs submissions to
 * `POST /api/public/intake-forms/{slug}/submit`.
 */
export default function PublicIntakeForm() {
  const { slug } = useParams();
  const [spec, setSpec] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancel = false;
    // Use axios WITHOUT credentials to avoid leaking cookies to public form.
    const client = axios.create({ withCredentials: false });
    client.get(`${API_BASE}/public/intake-forms/${slug}`)
      .then(({ data }) => { if (!cancel) setSpec(data); })
      .catch((e) => { if (!cancel) setError(formatApiError(e)); });
    return () => { cancel = true; };
  }, [slug]);

  const onSubmit = async (values) => {
    const client = axios.create({ withCredentials: false });
    const { data } = await client.post(
      `${API_BASE}/public/intake-forms/${slug}/submit`,
      { values, referrer: document.referrer || undefined },
    );
    return data;
  };

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center px-6" style={{ background: "var(--bg)" }}>
        <div className="max-w-md text-center" data-testid="public-form-error">
          <div className="overline mb-2">Form unavailable</div>
          <h1 className="font-heading text-3xl mb-2" style={{ fontWeight: 500 }}>Not found</h1>
          <p className="text-[13px] text-[var(--ink-2)]">{error}</p>
        </div>
      </div>
    );
  }

  if (!spec) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: "var(--bg)" }}>
        <span className="text-[12px] text-[var(--ink-3)]">Loading…</span>
      </div>
    );
  }

  return (
    <div className="min-h-screen py-12 px-4" style={{ background: "var(--bg)" }}>
      <div className="max-w-xl mx-auto">
        <PublicFormRenderer spec={spec} onSubmit={onSubmit} />
        <div className="text-center mt-6 text-[10px] uppercase tracking-wider text-[var(--ink-3)]">
          Powered by Practice OS
        </div>
      </div>
    </div>
  );
}
